<template>
    <div id="menuHeaderAdmin">
        <div class="row">
            <div class="linksWrapper mobileNot col-lg-10 col-md-10">
                <router-link class="menu-admin" to="/admin/components/new" tag="div" v-if="hasAccessCreate('product_manager')">
                    <a>{{ $t("headerAdmin.cpnt_management") }}</a>
                </router-link>
                <router-link class="menu-admin" to="/displayers" tag="div" v-if="hasAccessDiamAdmin()">
                    <a>{{ $t("headerAdmin.displayers") }}</a>
                </router-link>
                <router-link class="menu-admin" to="/admin/uploader" tag="div" v-if="hasAccessBothAdmin()">
                    <a>{{ $t("headerAdmin.uploadPage") }}</a>
                </router-link>
                <router-link class="menu-admin" to="/standDesign-list" tag="div" v-if="hasAccessDiamAdmin()">
                    <a>{{ $t("headerAdmin.design") }}</a>
                </router-link>
            </div>
            <div class="adminLeftSide col-lg-2 col-md-2">
                <div class="user-connect">
                    <div class="admin uppercase" v-if="!hasAccessSuperAdmin() && !hasAccessDiamAdmin()">{{ getBrand.name + " admin" }}</div>
                    <div class="admin uppercase" v-else-if="!hasAccessSuperAdmin() && hasAccessDiamAdmin()">{{ "REM3RCH admin" }}</div>
                    <div class="admin uppercase" v-else-if="hasAccessSuperAdmin()">{{ $t("headerAdmin.super_admin") }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            getBrand: "brand/getBrand",
            getLogoRem3rch: "brand/getLogoRem3rch",
            getBackgroundColor: "brand/getBackgroundColor"
        })
    }
};
</script>
<style scoped lang="scss">
@import "../../assets/css/themes.scss";

.themeSelecter {
    @extend %primary-text;
}
#menuHeaderAdmin {
    position: relative;
    padding: 14px 0;
    background-color: #727a96;
    @media only screen and (max-width: 767px) {
        padding: 12px 0;
    }
    .linksWrapper {
        font-size: 1.4rem;
        & .menu-admin {
            border-right: 1px solid #727a96;
            display: table-cell;
            vertical-align: middle;
            /*height: 45px;*/
            /*padding-top: 15px;*/
            @media only screen and (max-width: 992px) {
                text-align: center;
                /*height: auto;*/
            }
            a {
                color: white;
                text-transform: uppercase;
                text-decoration: none;
                margin: 0 20px;
                display: block;
                &:hover {
                    color: white;
                    transition: all 0.3s;
                }
                &:first-child {
                    border: none;
                }
            }
        }
        .router-link-active {
            border-bottom: 2px #fff solid;
            font-weight: bold;
        }
    }
}

.adminLeftSide {
    padding-right: 15px;
    border-left: 1px solid #727a96;
    .user-connect {
        text-align: right;
        right: 30px;
        position: relative;
        @media only screen and (max-width: 767px) {
            text-align: left;
            right: 0;
        }
        .admin {
            right: 15px;
            font-family: Roboto;
            font-size: 14px;
            color: white;
            display: inline-block;
            &:before {
                content: "";
                display: inline-block;
                width: 18px;
                height: 15px;
                margin-right: 5px;
                background-image: url("../../../static/img/user.png");
            }
        }
        img {
            margin-left: 15px;
            margin-right: 12px;
            float: left;
        }
    }
}

@media only screen and (max-width: 767px) {
    .adminLeftSide {
        .admin {
            margin-left: 10px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// HeaderAdmin.vue?0247ff20